import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { oCurrencyFormatter } from 'utils/common';
import { selectEventsToEdit } from '../redux/selectors';

const EventEditConfirmationFooter = () => {
  const iTotalCost = useSelector((state) => state.Checkout.checkoutTotal);
  const aEditedEventsInCart = useSelector(selectEventsToEdit);
  const iTotalPreviouslyPaid = aEditedEventsInCart.reduce(
    (iTotal, oEventInCart) => {
      const { aGuests } = oEventInCart.oDetails;
      const { TOTAL_AMOUNT_PAID = 0 } =
        aGuests.find((oGuest) => oGuest.ROLE === 'currentHost') ?? {};
      return iTotal + TOTAL_AMOUNT_PAID;
    },
    0
  );
  const iSubTotal = aEditedEventsInCart.reduce((iTotal, oEventInCart) => {
    const { aGuests } = oEventInCart.oDetails;
    const iGuestTotal = aGuests.reduce(
      (iSum, oGuest) => iSum + (oGuest.REG_OPTION.COST ?? 0),
      0
    );
    return iTotal + iGuestTotal;
  }, 0);
  const [oSearchParams] = useSearchParams();
  const sPaymentTransactionId = oSearchParams.get('transid');
  return (
    <div className='eventConfirmation__footer'>
      <hr className='eventConfirmation__footerDivider' />
      <p className='t-paragraph--small'>
        Subtotal: {oCurrencyFormatter.format(iSubTotal)}
      </p>
      <p className='t-paragraph--small'>
        You previously paid: {oCurrencyFormatter.format(iTotalPreviouslyPaid)}
      </p>
      <p className=' t-paragraph--bold'>
        Updated Additional Cost: {oCurrencyFormatter.format(iTotalCost)}
      </p>
      {iTotalCost > 0 && (
        <p
          className='t-paragraph--small'
          data-cy='confirmation-transaction-confirmation'
        >
          Transaction Confirmation: #
          <span data-cy='confirmation-transaction-id'>
            {sPaymentTransactionId}
          </span>
        </p>
      )}
    </div>
  );
};

export default EventEditConfirmationFooter;
